import React from 'react';
import { motion } from 'framer-motion';
const chapters = [{
  number: '01',
  title: 'Tus Derechos Constitucionales',
  description: 'Lo que ICE no puede hacer, incluso sin papeles.'
}, {
  number: '02',
  title: 'El Plan Familiar de Emergencia',
  description: 'Cómo preparar a tu familia para lo inesperado.'
}, {
  number: '03',
  title: 'Documentos Esenciales',
  description: 'Qué papeles necesitas tener listos HOY.'
}, {
  number: '04',
  title: 'Si Tocan Tu Puerta',
  description: 'Paso a paso: qué decir y qué NO decir.'
}, {
  number: '05',
  title: 'Poder Legal y Custodia',
  description: 'Protege a tus hijos con documentos legales.'
}, {
  number: '06',
  title: 'Tus Derechos en el Trabajo',
  description: 'Lo que tu empleador no te puede hacer.'
}, {
  number: '07',
  title: 'Recursos Legales Gratuitos',
  description: 'Organizaciones que te ayudan sin cobrar.'
}, {
  number: '08',
  title: 'Salud Mental y Resiliencia',
  description: 'Cuidar tu bienestar emocional en tiempos difíciles.'
}, {
  number: '09',
  title: 'Comunidad y Red de Apoyo',
  description: 'Cómo crear tu círculo de protección.'
}, {
  number: '10',
  title: 'Educación y Escuelas',
  description: 'Los derechos de tus hijos en el sistema escolar.'
}, {
  number: '11',
  title: 'Finanzas y Protección Económica',
  description: 'Asegura el futuro financiero de tu familia.'
}, {
  number: '12',
  title: 'Tu Voz Importa',
  description: 'Cómo abogar por tu comunidad sin miedo.'
}];
export function ChapterList() {
  return <section className="py-24 bg-[#0c1222] text-white border-t border-white/10" data-id="element-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-30">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4 uppercase tracking-wide" data-id="element-31">
            Qué Vas a Aprender
          </h2>
          <p className="text-gray-400 font-sans text-lg max-w-2xl mx-auto" data-id="element-32">
            Una guía completa de 12 capítulos para proteger lo que más importa
          </p>
          <div className="w-24 h-1 bg-[#c0392b] mx-auto mt-8" data-id="element-33" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-12" data-id="element-34">
          {chapters.map((chapter, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05,
          duration: 0.5
        }} className="group flex items-start border-b border-white/10 pb-8 hover:border-[#c0392b] transition-colors duration-300" data-id="element-35">
              <span className="font-serif text-4xl md:text-5xl font-bold text-[#c0392b] mr-6 opacity-80 group-hover:opacity-100 transition-opacity" data-id="element-36">
                {chapter.number}
              </span>
              <div data-id="element-37">
                <h3 className="font-sans font-bold text-xl md:text-2xl text-white mb-2 group-hover:text-[#c0392b] transition-colors duration-300" data-id="element-38">
                  {chapter.title}
                </h3>
                <p className="font-sans text-gray-400 leading-relaxed" data-id="element-39">
                  {chapter.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}